import React from 'react';
import { Navigation } from '@shopify/polaris';
import { AlertBubbleIcon } from '@shopify/polaris-icons';
import { useLocation } from 'react-router-dom';

const CollectionsSidebar: React.FC = () => {
  const location = useLocation();

  return (
    <Navigation location={location.pathname}>
      <Navigation.Section
        items={[
          {
            label: 'Admin Collections',
            url: '/collections/clients',
            icon: AlertBubbleIcon as any,
            matches: true,
            subNavigationItems: [
              {
                label: 'Clients',
                url: '/collections/clients',
                disabled: false,
              },
              {
                label: 'Configuration',
                url: '/collections/configuration',
                disabled: false,
              },
              {
                label: 'Scheduled Emails',
                url: '/collections/scheduled-emails',
                disabled: false,
              },
              {
                label: 'Email History',
                url: '/collections/email-history',
                disabled: false,
              },
            ],
          },
        ]}
      />
    </Navigation>
  );
};

export default CollectionsSidebar;
